var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChooseRobot = function SvgChooseRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCDC7B",
    fillRule: "evenodd",
    d: "M7.8 0a2.4 2.4 0 0 0-2.4 2.4v11.2h19.2V2.4A2.4 2.4 0 0 0 22.2 0zm4 7.2a1.6 1.6 0 1 0-3.2 0 1.6 1.6 0 0 0 3.2 0m8-1.6a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCDC7B",
    d: "M2.2 8A1.6 1.6 0 0 0 .6 9.6v8a1.6 1.6 0 0 0 1.788 1.589q.104.01.212.011h24.8q.106 0 .21-.011.094.01.19.011a1.6 1.6 0 0 0 1.6-1.6v-8a1.6 1.6 0 1 0-3.2 0v5.6H3.8V9.6A1.6 1.6 0 0 0 2.2 8M5.8 20.8A1.2 1.2 0 0 0 4.6 22v.8a1.2 1.2 0 0 0 2.4 0V22a1.2 1.2 0 0 0-1.2-1.2M23 22a1.2 1.2 0 0 1 2.4 0v.8a1.2 1.2 0 0 1-2.4 0z"
  })));
};
export default SvgChooseRobot;